<style lang="scss">
tbody i {
    margin-left: 10px;
}
</style>

<template>
    <div class="row justify-content-start">
        <div class="col-auto">
            <div class="input-group input-group-sm mb-3">
                <span class="input-group-text" id="filter">{{ $trans("event.name") }} / {{ $trans("event.organizer") }}</span>
                <input v-model="filter" type="text" class="form-control" aria-describedby="filter" />
            </div>
        </div>
        <div class="col-auto">
            <div class="form-check">
                <input id="inactiveOnly" v-model="inactiveOnly" class="form-check-input" type="checkbox" @change="loadPage" />
                <label class="form-check-label" for="inactiveOnly">
                    {{ $trans("acp.inactive_only") }}
                </label>
            </div>
        </div>
    </div>

    <table class="table table-dark table-striped">
        <thead>
            <tr>
                <th scope="col">{{ $trans("company.id") }}</th>
                <th scope="col">{{ $trans("event.name") }}</th>
                <th scope="col">{{ $trans("event.organizer") }}</th>
                <th scope="col">{{ $trans("event.starting_at") }}</th>
                <th scope="col">{{ $trans("event.ending_at") }}</th>
                <th scope="col" class="text-center">{{ $trans("event.active") }}</th>
                <th scope="col" class="text-center">{{ $trans("acp.options") }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="event in events.data" :key="event.id">
                <th scope="row">{{ event.id }}</th>
                <td>{{ event.name }}</td>
                <td>{{ event.organizer_name }}</td>
                <td>{{ event.starting_at }}</td>
                <td>{{ event.ending_at }}</td>
                <td class="text-center">
                    <i v-if="event.active" class="fas fa-check"></i>
                    <i v-else class="fas fa-times"></i>
                    <a class="text-light" style="cursor:pointer" :title="event.active ? $trans('acp.event_deactivate') : $trans('acp.event_activate')" @click="toggleActive(event)">
                        <i :class="event.active ? 'fas fa-toggle-on fa-lg' : 'fas fa-toggle-off fa-lg'"></i>
                    </a>
                </td>
                <td class="text-center">
                    <Link :href="route('acp.events.show', { event: event.id })" class="text-light">
                        <i class="far fa-eye fa-lg"></i>
                    </Link>
                    <a class="text-light" style="cursor:pointer" @click="_delete(event.id)">
                        <i class="far fa-trash-alt fa-lg"></i>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>

    <pagination ref="pagination" v-model="events.current_page" :options="paginationOptions" :records="events.total" :per-page="events.per_page" @paginate="loadPage()" />

    <div id="modal" class="modal fade" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 id="modalLabel" class="modal-title">{{ $trans("acp.title_modal_delete_event") }}</h5>
                    <button type="button" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times fa-2x"></i></button>
                </div>
                <div class="modal-body">{{ $trans("acp.body_modal_delete_event") }}</div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $trans("acp.close") }}</button>
                    <button type="button" class="btn btn-primary" @click="deleteAction()">{{ $trans("acp.delete") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ACPLayout from "@/Layouts/ACP";
import { markRaw } from "vue";
import { Modal } from "bootstrap";
import { Link } from "@inertiajs/inertia-vue3";
import Pagination from "v-pagination-3";
import CustomPagination from "@/Components/Pagination.vue";

export default {
    layout: ACPLayout,
    components: { Link, Pagination, CustomPagination },

    props: {
        events: Object,
    },

    data() {
        return {
            eventId: 0,
            modal: false,
            filter: "",
            filterTimeout: false,
            inactiveOnly: false,
            paginationOptions: { template: markRaw(CustomPagination) },
        };
    },

    watch: {
        filter() {
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(() => this.loadPage(), 1000);
        },
    },

    methods: {
        loadPage(page = false) {
            this.$inertia.reload({
                data: {
                    page: page === false ? this.events.current_page : page,
                    filter: this.filter,
                    inactiveOnly: this.inactiveOnly,
                },
                only: ["events"],
            });
        },
        toggleActive(event) {
            axios.patch(route("acp.events.activate", { event: event.id })).then((res) => {
                event.active = res.data.active;
            });
        },
        _delete(id) {
            this.eventId = id;
            this.modal = new Modal(document.getElementById("modal"));
            this.modal.show();
        },
        deleteAction() {
            axios
                .delete(route("acp.events.destroy", { event: this.eventId }))
                .then(() => {
                    this.$inertia.reload({
                        data: { page: this.events.current_page, filter: this.filter, inactiveOnly: this.inactiveOnly },
                        only: ["events"],
                    });
                    this.modal.hide();
                });
        },
    },
};
</script>
